import { DoctorStatus } from '@enum/doctor/DoctorStatus';

export class DoctorExportCriteriaDTO {
  public status: DoctorStatus;
}